import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, Package, FolderOpen, Users, FileText, Settings, LogOut, ShoppingCart } from 'lucide-react';
import { Button } from '../components/ui/button';

const AdminLayout = ({ children, title }) => {
  const { logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { path: '/admin', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/admin/categories', icon: FolderOpen, label: 'Categorias' },
    { path: '/admin/products', icon: Package, label: 'Produtos' },
    { path: '/admin/users', icon: Users, label: 'Usuários' },
    { path: '/admin/reports', icon: FileText, label: 'Relatórios' },
    { path: '/admin/settings', icon: Settings, label: 'Configurações' },
  ];

  return (
    <div className="flex h-screen bg-[#09090b]">
      <div className="w-64 border-r border-white/10 bg-[#09090b] flex flex-col">
        <div className="p-6 border-b border-white/10">
          <h1 className="text-2xl font-bold font-oswald text-[#FF5500]">BÉNI ADMIN</h1>
          <p className="text-white/60 text-sm font-inter mt-1">Painel de Controle</p>
        </div>

        <nav className="flex-1 p-4 space-y-2">
          {menuItems.map(item => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`menu-${item.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg font-inter transition-all ${
                  isActive
                    ? 'bg-[#FF5500] text-white shadow-lg'
                    : 'text-white/70 hover:bg-white/5 hover:text-white'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-white/10 space-y-2">
          <Button
            data-testid="pos-button"
            onClick={() => navigate('/pos')}
            className="w-full bg-white/10 hover:bg-white/20 text-white border border-white/10 justify-start"
          >
            <ShoppingCart className="w-5 h-5 mr-3" />
            Ir para Vendas
          </Button>
          <Button
            data-testid="logout-admin-button"
            onClick={() => {
              logout();
              navigate('/login');
            }}
            variant="outline"
            className="w-full border-white/20 text-white hover:bg-white/10 justify-start"
          >
            <LogOut className="w-5 h-5 mr-3" />
            Sair
          </Button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="p-8">
          <h2 className="text-3xl font-bold font-oswald text-white mb-6">{title}</h2>
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;